<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          
          @click="getList"
          >刷新</el-button
        >
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1141px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
       <el-table-column prop="address" label="操作" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isSystem">-</div>
            <el-button
              v-else
              type="primary"
              class="edit-button"
              size="mini"
              
              @click="edit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column> 
        <el-table-column prop="level" label="等级" width="100" />
        <el-table-column prop="withdrawSum" label="图片" width="100">
          <template slot-scope="scoped">
            <el-image
              style="width: 60px;"
              :src="scoped.row.image"
              fit="fill"
              :preview-src-list="new Array(scoped.row.image)"
              @click.stop="handleClickItem"
            />
          </template>
        </el-table-column>
        <el-table-column prop="minAmount" label="最低持仓" width="100" />
        <el-table-column prop="promotionDays" label="晋升考核天数" width="120" />
        <el-table-column prop="subsidyAmount" label="仓库补贴金额" width="120" />
        <el-table-column prop="orders" label="1层比例" width="100">
          <template slot-scope="scoped">
            <div>{{ scoped.row.pro1 }}%</div>
          </template>
        </el-table-column>
        <el-table-column prop="orders" label="2层比例" width="100">
          <template slot-scope="scoped">
            <div>{{ scoped.row.pro2 }}%</div>
          </template>
        </el-table-column>
        <el-table-column prop="orders" label="3-5层比例" width="100">
          <template slot-scope="scoped">
            <div>{{ scoped.row.pro3 }}%</div>
          </template>
        </el-table-column>
        <el-table-column prop="orders" label="6-10层比例" width="100">
          <template slot-scope="scoped">
            <div>{{ scoped.row.pro4 }}%</div>
          </template>
        </el-table-column>
        <el-table-column prop="orders" label="11-20层比例" width="100">
          <template slot-scope="scoped">
            <div>{{ scoped.row.pro5 }}%</div>
          </template>
        </el-table-column>
      </el-table> 
      <!-- 分页 --> 
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
      <!-- 编辑 -->
      <el-dialog
        :visible.sync="dialogVisibleUpdate"
        width="600px"
        title="编辑"
        :before-close="editClose"
        :close-on-click-modal="false"
      >
       <!-- 表单 -->
       <el-form ref="form" :model="editForm" label-width="150px" size="mini">
          <el-form-item label="等级">
            <el-input v-model="editForm.level" placeholder="请输入等级"/>
          </el-form-item>
          <el-form-item label="最低持仓">
            <el-input v-model="editForm.minAmount" placeholder="请输入最低持仓"/> USDT
          </el-form-item>
          <el-form-item label="晋升考核天数">
            <el-input v-model="editForm.promotionDays" placeholder="请输入晋升考核天数"/>
          </el-form-item>
          <el-form-item label="仓库补贴金额">
            <el-input v-model="editForm.subsidyAmount" placeholder="请输入仓库补贴金额"/> USDT
          </el-form-item>
          <el-form-item label="1层比例">
            <el-input v-model="editForm.pro1" placeholder="请输入1层比例"/>
          </el-form-item>
          <el-form-item label="2层比例">
            <el-input v-model="editForm.pro2" placeholder="请输入2层比例"/>
          </el-form-item>
          <el-form-item label="3-5层比例">
            <el-input v-model="editForm.pro3" placeholder="请输入3-5层比例"/>
          </el-form-item>
          <el-form-item label="6-10层比例">
            <el-input v-model="editForm.pro4" placeholder="请输入6-10层比例"/>
          </el-form-item>
          <el-form-item label="11-20层比例">
            <el-input v-model="editForm.pro5" placeholder="请输入11-20层比例"/>
          </el-form-item>
          <el-form-item>
            <el-popconfirm title="确定更新？" @confirm="bannerUpdate()">
            <el-button
              slot="reference"
              type="primary"
              class="edit-button"
            >更新</el-button>
          </el-popconfirm>
          </el-form-item>
  
        </el-form>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
  
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination,VueUeditorWrap,UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: { },
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        multipleSelection: [], // 选中项s
        yiFangDetailList: [], // 
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        edit_dialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        buttongLoding: false, // 按钮加载
        sn:'',
        lang:'en',
        isEnabled:false,
        isChat:false,
        isTelegram:false,
        isWhatsApp:false,
        isMessenger:false,
        isLinkUrl:false,
        isTelegramGroup:false,
        dialogVisibleUpdate:false,
        dataTime:['',''],
        yifangId:''
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
     
      
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector('.el-image-viewer__mask')
          if (!domImageMask) {
            return
          }
          domImageMask.addEventListener('click', () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector('.el-image-viewer__close').click()
          })
        })
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
          this.$api.operate
          .teamLevelConfigList(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
       // 编辑
      edit(row) {
        this.editForm = JSON.parse(JSON.stringify(row));
        this.dialogVisibleUpdate = true;
      },
      bannerUpdate() {
        this.$api.operate
          .teamLevelConfigUpdate(this.editForm)
          .then((res) => {
            this.$message.success(res);
            this.dialogVisibleUpdate = false;
            this.getList();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.buttongLoding = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭添加弹窗
      handleClose() {
        this.$refs.active.resetFields();
      },
      // 关闭修改弹窗
      editClose(done) {
        this.editInfo = {};
        done();
      },
      // 删除选中项
      handleDel() {
        var ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        var params = {
          ids: ids.toString(),
        };
        this.$api.operate
          .bannerDelete(params)
          .then((res) => {
            this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.getList();
          });
      },
      // 打开添加弹窗
      open() {
        this.dialogVisible = true;
        this.active = {}
        this.$nextTick(() => {
          this.$refs.imageEn.init('');
          this.$refs.imageEs.init('');
          this.$refs.imageFr.init('');
          this.$refs.imageDe.init('');
          this.$refs.imagePt.init('');
          this.$refs.imageTr.init('');
          this.$refs.imageGr.init('');
          this.$refs.imageEg.init('');
          this.$refs.imageIt.init('');
          this.$refs.imageIr.init('');
          this.$refs.imageNl.init('');
          this.$refs.imageIn.init('');
          this.$refs.imageUz.init('');
          this.$refs.imageVn.init('');
          this.$refs.imageKo.init('');
          this.$refs.imageId.init('');
          this.$refs.imageRu.init('');
          this.$refs.imagePl.init('');
          this.$refs.imageHu.init('');
          this.$refs.imageRo.init('');
        });
      },
      happenTimeFun(num){
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      return y + '-' + MM + '-' + d
  },
      // 添加用户
      bannerSave() {
            this.$api.operate
              .bannerSave(this.active)
              .then((res) => {
                this.$message.success(res);
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
                this.buttongLoding = false;
              });
      },
      // 打开删除弹窗
      openDelete() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleDel();
          })
          .catch(() => {
            
          });
      },
     
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  </style>
  